export interface UmpireSquadStats {
  ball_possession: string;

  goals_conceded: string;

  goals_scored: string;

  last_five_matches: string[];

  points: string;

  points_away: string;

  points_home: string;

  position: string;

  shots: string;

  shots_on_target: string;
}
